module.exports = ".newCompany {\n  margin-top: -40px;\n  margin-right: 7px;\n  float: right; }\n\ndiv.companiesCard {\n  margin-top: 0em; }\n"